/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades/entidades/divisionesTiposPropiedades';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import DivisionesTiposPropiedadesCM from '../controladorModelo/divisionesTiposPropiedadesCM';
import { IFormularioDivisionesTiposPropiedadesCVProps } from '../interfaces';
import { acciones, IEstadoDivisionesTiposPropiedades } from '../reductorDivisionesTiposPropiedades';
import FormularioDivisionesTiposPropiedadesVista from '../vista/formularioDivisionesTiposPropiedadesVista';
import { useSelector } from 'react-redux';

const estadoInicial: IDivisionesTiposPropiedades = {
    EmpresaId: '',
    DivisionTipoPropiedadDescripcion: '',
    Propiedad: '',
    Estado: 1,
    AgenciaId: '',
};
const divisionesTiposPropiedadesCM = new DivisionesTiposPropiedadesCM();

const FormularioDivisionesTiposPropiedadesCV: React.FunctionComponent<IFormularioDivisionesTiposPropiedadesCVProps> = ({
    IdEmpresa,
}) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadDivisionesTiposPropiedades }, dispatch] = useProveedor<
        IEstadoDivisionesTiposPropiedades
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IDivisionesTiposPropiedades>(estadoInicial);

    React.useEffect(() => {
        if (entidadDivisionesTiposPropiedades && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadDivisionesTiposPropiedades);
        } else {
            reiniciar();
        }
    }, [entidadDivisionesTiposPropiedades]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionDivisionesTiposPropiedades = () => {
        if (divisionesTiposPropiedadesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarDivisionesTiposPropiedades,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarDivisionesTiposPropiedades = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            divisionesTiposPropiedadesCM
                .crearDivisionesTiposPropiedades({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            divisionesTiposPropiedadesCM
                .editarDivisionesTiposPropiedades({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioDivisionesTiposPropiedadesVista
            accionCrearEditar={confirmarCreacionEdicionDivisionesTiposPropiedades}
            cambiarInfoFomulario={alCambiarValor}
            divisionesTiposPropiedades={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioDivisionesTiposPropiedadesCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioDivisionesTiposPropiedadesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioDivisionesTiposPropiedadesCV);
